import React, { useState } from 'react';

import { getBrandCDNUrl } from 'modules/shared/utils';
import { getDefaultUrlPicture } from 'modules/shared-cms/utils';

import { BrandImageProps } from './brand-image-type';

import styles from './brand-image-component.module.css';

export const BrandImage: React.FC<BrandImageProps> = (props: BrandImageProps) => {
    const [isError, setIsError] = useState(false);

    const { monogram, name, link, cmsLogo } = props;
    const logo = getDefaultUrlPicture(cmsLogo) || getBrandCDNUrl(monogram);
    if (!isError && logo) {
        return (
            <div className={styles.linkContainer}>
                {link ? (
                    <a href={link} target="blank">
                        <div className={styles.brandImageContainer}>
                            <picture>
                                <img alt={name} src={logo} onError={() => setIsError(true)} />
                            </picture>
                        </div>
                    </a>
                ) : (
                    <div className={styles.brandImageContainer}>
                        <picture>
                            <img alt={name} src={logo} onError={() => setIsError(true)} />
                        </picture>
                    </div>
                )}
            </div>
        );
    }
    return <React.Fragment></React.Fragment>;
};
